export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Cyrillic-c32b0c98c77e458414dc501d0f73bc56.woff";